import { render, staticRenderFns } from "./commonCommentList.vue?vue&type=template&id=76457f8c&scoped=true&"
import script from "./commonCommentList.vue?vue&type=script&lang=js&"
export * from "./commonCommentList.vue?vue&type=script&lang=js&"
import style0 from "./commonCommentList.vue?vue&type=style&index=0&id=76457f8c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76457f8c",
  null
  
)

export default component.exports